// import './bootstrap';

window.initPageScroller = function(config) {
    const DELEGATE_THRESHOLD = config.delegateThreshold;
    const DISPLAY_DURATION = config.displayDuration || 15;
    const SCROLL_DURATION = config.scrollDuration || 2000;

    const delegateCount = document.querySelectorAll('.delegate-item').length;

    if (delegateCount < DELEGATE_THRESHOLD) {
        return;
    }

    console.log("window.innerWidth", window.innerWidth);

    function isMobileDevice() {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
            || window.innerWidth < 768;
    }

    if (isMobileDevice()) {
        return;
    }

    const pageIndicator = document.getElementById('page-indicator');
    const pageNumber = document.getElementById('page-number');
    const countdownTimer = document.getElementById('countdown-timer');

    pageIndicator.style.display = 'block';

    let currentPage = 1;
    let totalPages = 2;
    let countdownSeconds = DISPLAY_DURATION;
    let countdownInterval;
    let pageChangeTimeout;

    function calculatePages() {
        const documentHeight = document.documentElement.scrollHeight;
        const viewportHeight = window.innerHeight;
        totalPages = Math.ceil(documentHeight / viewportHeight);
        if (totalPages < 2) totalPages = 2;
    }

    function updateDisplay() {
        pageNumber.textContent = `${currentPage}/${totalPages}`;
        countdownTimer.textContent = `0:${countdownSeconds.toString().padStart(2, '0')}`;
    }

    function smoothScrollTo(targetY) {
        window.scrollTo({
            top: targetY,
            behavior: 'smooth'
        });
    }

    function getScrollPositionForPage(page) {
        const documentHeight = document.documentElement.scrollHeight;
        const viewportHeight = window.innerHeight;
        const maxScroll = documentHeight - viewportHeight;

        if (page === 1) {
            return 60;
        } else if (page === totalPages) {
            return maxScroll;
        } else {
            return ((page - 1) / (totalPages - 1)) * maxScroll;
        }
    }

    function startCountdown() {
        countdownSeconds = DISPLAY_DURATION;
        updateDisplay();

        if (countdownInterval) {
            clearInterval(countdownInterval);
        }

        countdownInterval = setInterval(() => {
            countdownSeconds--;
            updateDisplay();

            if (countdownSeconds <= 0) {
                clearInterval(countdownInterval);
            }
        }, 1000);
    }

    function changePage() {
        currentPage++;
        if (currentPage > totalPages) {
            currentPage = 1;
        }

        const targetScroll = getScrollPositionForPage(currentPage);
        smoothScrollTo(targetScroll);

        startCountdown();
        scheduleNextPageChange();
    }

    function scheduleNextPageChange() {
        if (pageChangeTimeout) {
            clearTimeout(pageChangeTimeout);
        }
        pageChangeTimeout = setTimeout(changePage, DISPLAY_DURATION * 1000);
    }

    calculatePages();
    startCountdown();
    scheduleNextPageChange();

    window.addEventListener('resize', () => {
        calculatePages();
        updateDisplay();
    });
};
